export enum CollaborativeType {
    Destination = 1,
    Group = 2,

    // Agency = 3
}
